import styled from 'styled-components';

const CarouselStyled = styled.div`
  position: relative;

  .Carousel {
    &__gallery {
      height: 100%;
      display: grid;
      grid-template-columns: repeat(
        ${(props) => props.numberOfSlides},
        min(100vw, 100%)
      );
      grid-template-rows: 1fr;
      grid-auto-flow: column;
      overflow: hidden;
      scroll-snap-type: both mandatory;
      scroll-padding: 10px;
    }

    &__active {
      scroll-snap-type: unset;
    }

    &__item {
      scroll-snap-align: center;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }

    &__inner-item {
      max-width: 100%;
      max-height: 100%;
    }
  }
`;

export { CarouselStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
